import { call, options, params } from './helpers';

export const getPicklists = (payload) =>
	call(`/beta/picklists${params(payload)}`);
export const getPicklist = ({ id }) => call(`/beta/picklists/${id}`);
export const addPicklist = (payload) =>
	call(`/beta/picklists`, options(payload, 'POST'));

export const addInventoryToPicklist = ({ id, ...payload }) =>
	call(`/beta/picklists/${id}/add`, options(payload, 'PUT'));

export const removeInventoryFromPicklist = ({ id, ...payload }) =>
	call(`/beta/picklists/${id}/remove`, options(payload, 'PUT'));

export const updatePicklistStatus = ({ id, ...payload }) =>
	call(`/beta/picklists/${id}`, options(payload, 'PUT'));

/*export const updateModule = ({ id, ...payload }) =>
	call(`/beta/modules/${id}`, options(payload, 'PUT'));
export const addModule = (payload) =>
	call(`/beta/modules`, options(payload, 'POST'));
export const deleteModule = ({ id }) =>
	call(`/beta/modules/${id}`, options(null, 'DELETE'));
*/
